import React from 'react'
import Breadcrumb from './Breadcrumb';
import Footer from '../../components/footer/Footer';
import Blogarea from './Blogarea'
import HeaderOne from '../../components/header/HeaderOne';

function Blogs() {
  return (
	<>
	<HeaderOne/>
	<main>
	<Breadcrumb/>
	<Blogarea/>
	</main>
	<Footer/>
	
	</>
  )
}

export default Blogs